import { ConfirmModal } from '@apply/ui';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { saveStages } from '../';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { getDrawBudgetURL } from '../../../common/LoanFunctions';

export const EditBudgetButton = ({ property, styles, validateSubmission }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [isSaveModalOpen, set_isSaveModalOpen] = useState(false);

    const confirmSaveModal = async () => {
        await validateSubmission(null, saveStages.openBudget, property);

        set_isSaveModalOpen(false);
    };

    const cancelSaveModal = async () => {
        navigate(getDrawBudgetURL(property.drawBudgetId, location));

        set_isSaveModalOpen(false);
    };

    const onEditBudget = async () => {
        set_isSaveModalOpen(true);
    };

    return (
        <div style={styles.iconButton}>
            <button
                type='button'
                onClick={onEditBudget}
                className='button hollow'
                title='Edit Budget and Draws'
                style={{ marginRight: 10 }}
            >
                <FontAwesomeIcon icon={faPencil} />
            </button>
            <ConfirmModal
                isOpen={isSaveModalOpen}
                text='Do you want to save any change before opening the budget?'
                confirmButtonText='Save'
                cancelButtonText='Do not Save'
                confirmCallback={confirmSaveModal}
                cancelCallback={cancelSaveModal}
            />
        </div>
    );
};
